const AuthStatus = {
  LogIn: "LogIn", // Авторизація
  // Registered: "VerifyEmail", // Зареєструвався
  LogUp: "LogUp", // Реєстрація
  LogOut: "LogOut", //віхід
  ForfotPassword: "forgotPassword", //забув пароль
};

export default AuthStatus;